import {Component, Input} from '@angular/core';
import {faCheck, faClock, faListCheck, faRotateRight} from "@fortawesome/free-solid-svg-icons";
import {IFlowByStages, IFlowStatus} from "../../../../../data/interfaces/iflow.interface";
import {
  armarPasos,
  calcularAvance,
  IAvance,
  IResumenPasos,
  RESUMEN_VACIO
} from "../verification-documents-list/pasos-flujo";

// Encabezado (tarjeta hero) de la lista de pasos: nombre del flujo, «k de N
// listos» y la barra de avance. Estilos en _liga-ui.scss (.lx-hero, .lx-avance)
// y _liga-a.scss (.lx-a-*).
@Component({
  selector: 'app-progress-verification',
  templateUrl: './progress-verification.component.html',
  styleUrls: ['./progress-verification.component.scss']
})
export class ProgressVerificationComponent {
  readonly iconos = {
    lista: faListCheck,
    listo: faCheck,
    reloj: faClock,
    corrige: faRotateRight
  }

  // Porcentaje entero (0–100) del avance que se muestra.
  progress = 0
  avance: IAvance = {listos: 0, total: 0, porcentaje: 0}
  resumen: IResumenPasos = RESUMEN_VACIO

  private datos!: IFlowByStages

  @Input()
  set data(valor: IFlowByStages) {
    this.datos = valor
    this.resumen = armarPasos(valor)
    this.recalcular()
  }

  get data(): IFlowByStages {
    return this.datos
  }

  // El estado lo trae el padre (verify-information). Antes este componente hacía
  // su propio POST /flow/status al montarse, en paralelo con el del padre, y esa
  // tercera llamada simultánea también podía abrir una solicitud en el backend.
  private status: IFlowStatus | null = null

  @Input()
  set flowStatus(value: IFlowStatus | null) {
    this.status = value
    this.recalcular()
  }

  get flowStatus(): IFlowStatus | null {
    return this.status
  }

  get titulo(): string {
    return (this.status?.flow?.name ?? '').trim() || 'Tu solicitud'
  }

  get subtitulo(): string {
    // Con el contrato por firmar aún le toca algo: no se dice «todos tus pasos».
    if (this.todoListo && this.status?.status === 'PENDING_SIGNATURE') return 'Completaste tus pasos; solo falta firmar.'
    if (this.todoListo) return '¡Completaste todos tus pasos!'
    const flujo = this.status?.flow
    const texto = (flujo?.title ?? '').trim() || (flujo?.subtitle ?? '').trim()
    return texto && texto !== this.titulo ? texto : 'Completa cada paso para terminar tu solicitud.'
  }

  get todoListo(): boolean {
    return this.avance.total > 0 && this.avance.listos === this.avance.total
  }

  private recalcular() {
    this.avance = calcularAvance(this.resumen, this.status)
    this.progress = this.avance.porcentaje
  }
}
